export default __webpack_public_path__ + "static/media/like.bec15c70.svg";